<template>
  <section :class="isDarkMode ? 'text-[#FFFFFF]' : 'text-[#2663A3]'">
    <div :class="`grid bg-[${isDarkMode ? '#1F4F85' : '#F3F6FC'}]`">
      <div class="w-full mx-auto max-w-[1200px]">
        <div class="px-[16px] py-[24px] md:py-[48px]">
          <div
            class="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-8 lg:gap-0"
          >
            <div class="grid gap-6 sm:text-center lg:text-left">
              <div class="w-[126px] sm:mx-auto lg:mx-0">
                <img
                  :src="
                    isDarkMode
                      ? '/images/lan-ri-white-logo.png'
                      : '/images/lan-ri-logo.png'
                  "
                  class="w-full h-auto"
                />
              </div>
              <div
                class="grid sm:justify-center lg:justify-start text-sm sm:text-base"
              >
                Lembaga Administrasi Negara Jl.Veteran No.10 Jakarta Pusat
              </div>
              <div
                class="flex flex-col sm:flex-row gap-8 sm:gap-20 sm:justify-center lg:justify-start"
              >
                <div>
                  <div class="grid gap-2 sm:text-center lg:text-left">
                    <div class="font-bold text-sm sm:text-[20px]">ASN</div>
                    <NuxtLink
                      v-for="f1 in [
                        { name: 'Masuk', link: '/login' },
                        // { name: 'Dasar Hukum', link: '/' },
                        // { name: 'Tanya Jawab', link: '/' },
                      ]"
                      :to="f1.link"
                      :class="[
                        'text-sm sm:text-base transition-colors',
                        isDarkMode
                          ? 'hover:text-[#A8C5E8]'
                          : 'hover:text-[#1F4F85]',
                      ]"
                      :key="f1.name"
                    >
                      {{ f1.name }}
                    </NuxtLink>
                  </div>
                </div>
                <div>
                  <div class="grid gap-2 sm:text-center lg:text-left">
                    <div class="font-bold text-sm sm:text-[20px]">Panduan</div>
                    <NuxtLink
                      v-for="f2 in [
                        { name: 'Pelatihan Dasar CPNS', link: '/' },
                        { name: 'Orientasi PPPK', link: '/' },
                        { name: 'ASN Talent Academy', link: '/' },
                        { name: 'Pelatihan Sosial Kultural', link: '/' },
                      ]"
                      :to="f2.link"
                      :class="[
                        'text-sm sm:text-base transition-colors',
                        isDarkMode
                          ? 'hover:text-[#A8C5E8]'
                          : 'hover:text-[#1F4F85]',
                      ]"
                      :key="f2.name"
                    >
                      {{ f2.name }}
                    </NuxtLink>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid gap-8 lg:gap-15 sm:text-center lg:text-right">
              <div class="grid gap-4">
                <div
                  class="flex flex-col sm:flex-row gap-4 sm:justify-center lg:justify-end items-center"
                >
                  <div
                    class="flex gap-2 items-center sm:justify-center lg:justify-end"
                  >
                    <IconBrandYoutube size="20" />
                    <a
                      href="https://www.youtube.com/@LembagaAdministrasiNegaraRI"
                      target="_blank"
                      :class="[
                        'text-xs sm:text-sm transition-colors',
                        isDarkMode
                          ? 'hover:text-[#A8C5E8]'
                          : 'hover:text-[#1F4F85]',
                      ]"
                    >
                      Youtube LAN RI
                    </a>
                  </div>
                  <div
                    class="flex gap-2 items-center sm:justify-center lg:justify-end"
                  >
                    <IconBrandInstagram size="20" />
                    <a
                      href="https://www.instagram.com/humas_lan"
                      target="_blank"
                      :class="[
                        'text-xs sm:text-sm transition-colors',
                        isDarkMode
                          ? 'hover:text-[#A8C5E8]'
                          : 'hover:text-[#1F4F85]',
                      ]"
                    >
                      Instagram LAN RI
                    </a>
                  </div>
                  <div
                    class="flex gap-2 items-center sm:justify-center lg:justify-end"
                  >
                    <IconWorld size="20" />
                    <a
                      href="https://lan.go.id/"
                      target="_blank"
                      :class="[
                        'text-xs sm:text-sm transition-colors',
                        isDarkMode
                          ? 'hover:text-[#A8C5E8]'
                          : 'hover:text-[#1F4F85]',
                      ]"
                    >
                      Website LAN RI
                    </a>
                  </div>
                </div>
              </div>
              <div class="grid gap-2">
                <div class="font-bold text-sm sm:text-[20px]">
                  Helpdesk SIBangkom
                </div>
                <div
                  class="flex gap-2 sm:justify-center lg:justify-end items-center"
                >
                  <IconNotes size="20" />
                  <NuxtLink
                    :to="'/pusat-bantuan'"
                    style="text-decoration: none"
                    :class="[
                      'text-xs sm:text-sm transition-colors',
                      isDarkMode
                        ? 'hover:text-[#A8C5E8]'
                        : 'hover:text-[#1F4F85]',
                    ]"
                  >
                    Formulir Bantuan
                  </NuxtLink>
                </div>
              </div>
              <div
                class="flex gap-4 sm:gap-8 items-center justify-space-between lg:justify-end"
              >
                <div
                  v-for="f3 in [
                    {
                      img: isDarkMode ? 'berakhlak-white' : 'berakhlak-blue',
                      width: 'max-w-[128.5px]',
                    },
                    {
                      img: isDarkMode
                        ? 'bangga-melayani-white'
                        : 'bangga-melayani-blue',
                      width: 'max-w-[110px]',
                    },
                    { img: 'asn-komitmen', width: 'max-w-[92px]' },
                    { img: 'lan-ri-bbb', width: 'max-w-[54px]' },
                  ]"
                  :key="f3.img"
                  :class="f3.width"
                >
                  <img
                    :src="`/images/${f3.img}-logo.png`"
                    class="w-full h-auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="`grid ${
        isDarkMode ? 'bg-[#1E446E]' : 'bg-[#1F4F85]'
      } text-[#FFFFFF]`"
    >
      <div class="w-full mx-auto max-w-[1200px]">
        <div
          class="px-[16px] py-[12px] md:py-[30px] sm:text-center lg:text-right text-sm sm:text-base"
        >
          © SIBANGKOM ASN {{ year }}
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import {
  IconBrandInstagram,
  IconBrandYoutube,
  IconNotes,
  IconWorld,
} from "@tabler/icons-vue";

defineProps({
  isDarkMode: {
    type: Boolean,
    default: false,
  },
});
const year = new Date().getFullYear();
</script>
